import BrazilFlag from '../../assets/images/brazil.svg'
import ChinaFlag from '../../assets/images/china.svg'
import GermanyFlag from '../../assets/images/germany.svg'
import ItalyFlag from '../../assets/images/italy.svg'
import UsaFlag from '../../assets/images/usa.svg'

const COUNTRIES = [
  {
    label: 'Alemanha',
    value: 'germany',
    flag: GermanyFlag
  },
  {
    label: 'Brasil',
    value: 'brazil',
    flag: BrazilFlag
  },
  {
    label: 'China',
    value: 'china',
    flag: ChinaFlag
  },
  {
    label: 'Estados Unidos',
    value: 'usa',
    flag: UsaFlag
  },
  {
    label: 'Itália',
    value: 'italy',
    flag: ItalyFlag
  }
]

export default COUNTRIES